// src/App.js
import React, { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import AppRoutes from "./routes/Routes";
import Footer from "./components/Footer";
import TopBanner from "./components/TopBanner";
import "./styles/App.css";

function App() {
  const [isBannerVisible, setIsBannerVisible] = useState(true);

  // Check localStorage on initial load
  useEffect(() => {
    const isBannerClosed = localStorage.getItem("isBannerClosed");
    if (isBannerClosed === "true") {
      setIsBannerVisible(false);
    }
  }, []);

  // Handle closing the banner
  const handleCloseBanner = () => {
    setIsBannerVisible(false);
    localStorage.setItem("isBannerClosed", "true");
  };

  return (
    <div className="app-container">
      {isBannerVisible && <TopBanner onClose={handleCloseBanner} />}
      <Navbar isBannerVisible={isBannerVisible} />
      <AppRoutes />
      <Footer />
    </div>
  );
}

export default App;